<template>
  <div class="add-node-btn-box">
    <div class="add-node-btn">
      <Poptip placement="right" v-model="visible">
        <button class="btn" type="button">
          <span class="iconfont"></span>
        </button>
        <div class="add-node-popover-body" slot="content">
          <a class="add-node-popover-item approver" @click="addType(1)">
            <div class="item-wrapper">
              <span class="iconfont"></span>
            </div>
            <p>审批人</p>
          </a>
          <a class="add-node-popover-item notifier" @click="addType(2)">
            <div class="item-wrapper">
              <span class="iconfont"></span>
            </div>
            <p>抄送人</p>
          </a>
          <a class="add-node-popover-item transactor" @click="addType(3)">
            <div class="item-wrapper">
              <span class="iconfont"></span>
            </div>
            <p>办理人</p>
          </a>
          <a class="add-node-popover-item condition" @click="addType(5)">
            <div class="item-wrapper">
              <span class="iconfont"></span>
            </div>
            <p>条件分支</p>
          </a>
        </div>
      </Poptip>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  props: ['childNodeP'],
  data() {
    return {
      visible: false
    };
  },
  methods: {
    addType(nodeType) {
      this.visible = false;
      if (nodeType != 5) {
        let data;
        if (nodeType == 1) {
          data = {
            nodeId: uuidv4(),
            nodeName: '审核人',
            error: true,
            nodeType: 1,
            auditType: 1,
            execType: 1,
            userType: 1,
            userNullProcType: 1,
            child: this.childNodeP,
            userNullAutoHighLeaderDepartment: false,
            nodeUserList: [],
            nodeExecUsers: []
          };
        } else if (nodeType == 2) {
          data = {
            nodeId: uuidv4(),
            nodeName: '抄送人',
            error: true,
            nodeType: 2,
            userType: 1,
            ccSelfSelectFlag: 1,
            child: this.childNodeP,
            nodeUserList: [],
            nodeExecUsers: []
          };
        } else if (nodeType == 3) {
          data = {
            nodeId: uuidv4(),
            nodeName: '办理人',
            error: true,
            nodeType: 3,
            execType: 2,
            userType: 1,
            userNullProcType: 1,
            child: this.childNodeP,
            nodeUserList: [],
            nodeExecUsers: []
          };
        }
        this.$emit('update:childNodeP', data);
      } else {
        this.$emit('update:childNodeP', {
          nodeId: uuidv4(),
          nodeName: '路由',
          nodeType: 5,
          child: null,
          branchList: [
            {
              nodeId: uuidv4(),
              nodeName: '条件1',
              error: true,
              nodeType: 4,
              priorityLevel: 1,
              conditionList: [],
              nodeUserList: [],
              boolSpelExpression: '',
              child: this.childNodeP
              // child: this.childNodeP
            },
            {
              nodeId: uuidv4(),
              nodeName: '其他条件',
              nodeType: 4,
              priorityLevel: 2,
              conditionList: [],
              nodeUserList: [],
              boolSpelExpression: true,
              child: null
            }
          ]
        });
      }
    }
  }
};
</script>
<style scoped lang="less">
.add-node-btn-box {
  width: 240px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    margin: auto;
    width: 2px;
    height: 100%;
    background-color: #cacaca;
  }

  .add-node-btn {
    user-select: none;
    width: 240px;
    padding: 20px 0 32px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    flex-grow: 1;

    .btn {
      outline: none;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      width: 30px;
      height: 30px;
      background: #3296fa;
      border-radius: 50%;
      position: relative;
      border: none;
      line-height: 30px;
      -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      .iconfont {
        color: #fff;
        font-size: 16px;
      }

      &:hover {
        transform: scale(1.3);
        box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
      }

      &:active {
        transform: none;
        background: #1e83e9;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
<style lang="less">
.add-node-popover-body {
  display: flex;

  .add-node-popover-item {
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    flex: 1;
    color: #191f25 !important;

    .item-wrapper {
      user-select: none;
      display: inline-block;
      width: 80px;
      height: 80px;
      margin-bottom: 5px;
      background: #fff;
      border: 1px solid #e2e2e2;
      border-radius: 50%;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      .iconfont {
        font-size: 35px;
        line-height: 80px;
      }
    }

    &.approver {
      .item-wrapper {
        color: #ff943e;
      }
    }

    &.notifier {
      .item-wrapper {
        color: #3296fa;
      }
    }
    &.transactor {
      .item-wrapper {
        color: #7d07f2;
      }
    }

    &.condition {
      .item-wrapper {
        color: #15bc83;
      }
    }

    &:hover {
      .item-wrapper {
        background: #3296fa;
        box-shadow: 0 10px 20px 0 rgba(50, 150, 250, 0.4);
      }

      .iconfont {
        color: #fff;
      }
    }

    &:active {
      .item-wrapper {
        box-shadow: none;
        background: #eaeaea;
      }

      .iconfont {
        color: inherit;
      }
    }
  }
}
</style>
